import React, { Component } from "react";
import AutomationIcon from "@mui/icons-material/Assistant";
import {
  Box,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  Paper,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Divider,
  Alert,
  Stack,
  Avatar,
  CircularProgress,
  Container,
  CssBaseline,
  FormHelperText,
  Chip,
  FormLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
  AddRounded as AddRoundedIcon,
} from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import Api from "../../services/api";
import { Styles } from "../../styles/material-styles";
import { connect } from "react-redux";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import Title from "../../components/title-name";
import { browserHistory } from "../../helpers/history";
import { Overlay } from "../../styles/global";
import { PapiroConsole } from "../../utils/papiroConsole";
import EmailConfig from "src/components/emailConfig/EmailConfig";
import * as CalledService from "../../services/called.service";
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";
import * as Service from "../../services/defaultaction.service";
import * as CalledOrganizationChecklistService from "../../services/calledorganizationchecklist.service";
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import SimpleCheckBox from "../../components/checkbox/check";
import AddCommonPlaceholder from "src/components/emailConfig/AddCommonPlaceholder";
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";
import SimpleAutoCompleteMultipleObservant from "../../components/auto-complete/autocomplete-multiple-observant";
import { DeleteForever, AttachFile, Delete, } from '@mui/icons-material';
import Dropzone from 'react-dropzone';
import SimpleDatePickerRequired from '../../components/date-pickers/inline-required';
import RegexInput from "src/components/regex-input/regex-input";
import { validateRegex } from "src/utils/macros/regex";

class MacroRegistration extends Component {
  constructor(props) {
    super(props);

    const { userSession } = this.props;

    this.actionRefs = {};
    this.isGlobalAdm = false;

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype == 0) {
        this.isGlobalAdm = true;
      }
    });

    this.state = {
      nomeAutomacao: "",
      ativo: true,
      macroShareMode: null,

      macroUsers: [],
      macroUsersSelected: [],
      allowCreatePrivateMacro: false,
      allowCreateShareMacro: false,
      macroTechnicalTeamSelected: [],

      acoes: [
        {
          tipo: null,
          valor: null,
          categoriaId: null,
          considerarCategoria: false,
          customOrganizationFilterFields: [],
          body: `Olá {{ticket.requester.name}},

Informamos que seu chamado foi atualizado.

Status: {{ticket.status.name}}
Prioridade: {{ticket.priority.name}}
Técnico responsável: {{ticket.technical.name}}

Para mais detalhes, acesse: {{ticket.url}}

Atenciosamente,
{{hirer.name}}`,
          subject: "Chamado #{{ticket.id}} - {{ticket.title}}",
          requestingUserId: "",
          newCallTitle: "",
          newCallDescription: "",
          newCallOrganizationId: "",
          newCallProperties: "",
          setCategoryOrganizationValue: "",
          setCategoryOrganizationId: "",
        },
      ],

      actionsFields: [],
      actionFieldDetail: [],

      errors: {},
      tagValue: "",

      loading: false,
      openNotification: false,
      notificationVariant: "success",
      notificationMessage: "",

      organizationsFilterList: [],
      statusFilterList: [],
      typeFilterList: [],
      assignedUserFilterList: [],
      techinicalTeamFilterList: [],
      priorityFilterList: [],
      categoriesFilterList: [],
      defaultactionFilterList: [],
      localizationFilterList: [],
      userRequestFilterList: [],

      loadingUsers: false,
      loadingOrganizationFilter: false,
      loadingCategoryFilter: false,
      loadingStatusFilter: false,
      loadingTypeFilter: false,
      loadingAssignedUserFilter: false,
      loadingTechinicalTeamFilter: false,
      loadingPriorityFilter: false,
      loadingDefaultactionFilter: false,
      loadingLocalizationFilter: false,
      loadingUserRequestFilter: false,

      organizationId: null,
      customOrganizationFilterFields: [],
      customOrganizationFilterFieldsValues: [],
      customOrganizationFilterFieldsList: [],
      files: [],
    };
  }

  getOrCreateActionRef = (index) => {
    if (!this.actionRefs[index]) {
      this.actionRefs[index] = React.createRef();
    }
    return this.actionRefs[index];
  };

  componentDidMount = async () => {
    this.setState({ loading: true });

    await Promise.allSettled([
      this.getActionsFields(),
      this.getUserConfig(),
      this.getUsers(),
      this.getFilterTechinicalTeam(),
    ]);

    this.setState({ loading: false });
  }

  getUsers = async () => {
    let url = `/users/search/technician`;

    await Api.get(url)
      .then(result => {
        if (result.data.success) {
          const data = result.data.data;

          this.setState({ macroUsers: data });
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  getUserConfig() {
    this.setState({ loading: true });
    let url = `/userconfigs/logged`;

    Api.get(url)
      .then(result => {
        if (result.data.success) {
          if(this.isGlobalAdm) {
            this.setState({
              loading: false,
              allowCreatePrivateMacro: true,
              allowCreateShareMacro: true
            });
          } else if(result.data.data != null && (result.data.data?.allowcreateprivatemacro || result.data.data?.allowcreatesharemacro)) {
            this.setState({
              allowCreatePrivateMacro: result.data.data?.allowcreateprivatemacro,
              allowCreateShareMacro: result.data.data?.allowcreatesharemacro,
            });
          }
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  //Carregamento dos campos select
  showMessageIfDontHaveData = () => {
    this.setState({
      openNotification: true,
      notificationVariant: "warning",
      notificationMessage: "Não existem dados para esse campo",
    });
  };

  getFilterDefaultAction = async () => {
    if (
      this.state.defaultactionFilterList.length > 0 ||
      this.state.loadingDefaultactionFilter
    ) {
      return;
    }

    this.setState({ loadingDefaultactionFilter: true });

    try {
      const result = await Service.getAll();
      if (result.success) {
        this.setState({ defaultactionFilterList: result.data });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingDefaultactionFilter: false });
  };

  getFilterLocalizationByOrganization = async () => {
    const organizationId = this.state.organizationId;

    if (!organizationId) return;
    if (this.state.loadingLocalizationFilter || this.state.localizationFilterList?.length > 0) return;

    this.setState({ loadingLocalizationFilter: true });

    try {
      const res = await CalledService.getOrganizationAddresses(organizationId);

      if (res.success == false || res?.data.length === 0) {
        this.showMessageIfDontHaveData?.();
      }

      this.setState({
        localizationFilterList: res.data,
        loadingLocalizationFilter: false
      });
    } catch (err) {
      const { intl } = this.props;
      this.setState({
        loadingLocalizationFilter: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }
  };

  getFilterRequestUserByOrganization = async () => {
    const organizationId = this.state.organizationId;

    if (!organizationId) return;
    if (this.state.loadingUserRequestFilter || this.state.userRequestFilterList?.length > 0) return;

    this.setState({ loadingUserRequestFilter: true });

    try {
      const res = await CalledService.getRequestingUsers(organizationId);

      if (res.success == false || res?.data.length === 0) {
        this.showMessageIfDontHaveData?.();
      }

      this.setState({
        userRequestFilterList: res.data,
        loadingUserRequestFilter: false
      });
    } catch (err) {
      const { intl } = this.props;
      this.setState({
        loadingUserRequestFilter: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }
  };
  
  getFilterCategoriesByOrganization = async () => {
    const organizationId = this.state.organizationId;

    if (!organizationId) return;
    if (this.state.loadingCategoryFilter || this.state.categoriesFilterList.length > 0) return;

    this.setState({ loadingCategoryFilter: true });

    try {
      const res = await CalledService.getCategoriesByOrganizationDapper(organizationId);
      if (res.data.length === 0 || res.success == false) {
        this.showMessageIfDontHaveData?.();
      }

      this.setState({
        categoriesFilterList : res.data,
        loadingCategoryFilter: false,
      });
    } catch (err) {
      const { intl } = this.props;
      this.setState({
        loadingCategoryFilter: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }
  };

  getFilterPriority = async () => {
    if (
      this.state.priorityFilterList.length > 0 ||
      this.state.loadingPriorityFilter
    ) {
      return;
    }

    this.setState({ loadingPriorityFilter: true });

    try {
      const result = await CalledService.getPriority();
      if (result.success) {
        this.setState({ priorityFilterList: result.data });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingPriorityFilter: false });
  };

  getFilterStatus = async () => {
    if (
      this.state.statusFilterList.length > 0 ||
      this.state.loadingStatusFilter
    ) {
      return;
    }

    this.setState({ loadingStatusFilter: true });

    try {
      const result = await CalledService.getStatusDapper();
      if (result.success) {
        this.setState({
          statusFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingStatusFilter: false });
  };

  getFilterType = async () => {
    if (this.state.typeFilterList.length > 0 || this.state.loadingTypeFilter) {
      return;
    }

    this.setState({ loadingTypeFilter: true });

    try {
      const result = await CalledService.getTypesDapper();
      if (result.success) {
        this.setState({
          typeFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });
        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingTypeFilter: false });
  };

  getFilterAssignedUser = async () => {
    if (
      this.state.assignedUserFilterList.length > 0 ||
      this.state.loadingAssignedUserFilter
    ) {
      return;
    }

    this.setState({ loadingAssignedUserFilter: true });

    try {
      const result = await CalledService.getTechinicalUsersDapper();
      if (result.success) {
        this.setState({
          assignedUserFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingAssignedUserFilter: false });
  };

  getFilterTechinicalTeam = async () => {
    if (
      this.state.techinicalTeamFilterList.length > 0 ||
      this.state.loadingTechinicalTeamFilter
    ) {
      return;
    }

    this.setState({ loadingTechinicalTeamFilter: true });

    try {
      const result = await CalledService.getFilterTechinicalTeamDapper();
      if (result.success) {
        this.setState({
          techinicalTeamFilterList:
            result.data && result.data.length > 1
              ? result.data.sort((a, b) => a.name.localeCompare(b.name))
              : result.data,
        });

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "process.error" }),
      });
    }

    this.setState({ loadingTechinicalTeamFilter: false });
  };

  getFilterOrganizations = async () => {
    if (
      this.state.organizationsFilterList.length > 0 ||
      this.state.loadingOrganizationFilter
    ) {
      return;
    }

    this.setState({ loadingOrganizationFilter: true });

    const { userSession } = this.props;

    let orgData = [];

    if (
      userSession &&
      userSession.user &&
      userSession.user.userorganizations &&
      userSession.user.userorganizations.length > 0
    ) {
      orgData = userSession.user.userorganizations;
      const result = await CalledService.getOrganizationsDapper();
      if (result.success) {
        orgData = result.data;

        if (result.data?.length == 0) {
          this.showMessageIfDontHaveData();
        }
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            result.response &&
              result.response.data &&
              result.response.data.errors
              ? result.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(result);
      }
    }

    if (orgData != null) {
      orgData = orgData.filter((c) => c.active == true);
      this.setState({
        locationFilterList: [],
        categoriesFilterList: [],
        deptFilterList: [],
        customOrganizationFilterFields: [],
        customOrganizationFilterFieldsValues: [],
        customOrganizationFilterFieldsList: [],
        organizationsFilterList:
          orgData && orgData.length > 1
            ? orgData.sort((a, b) => a.name.localeCompare(b.name))
            : orgData,
      });
    } else {
      orgData = [];
      this.setState({
        organizationsFilterList:
          orgData && orgData.length > 1
            ? orgData.sort((a, b) => a.name.localeCompare(b.name))
            : orgData,
      });
    }

    this.setState({ loadingOrganizationFilter: false });
  };

  //Bloco de ações
  //Bloco de carregamento das ações
  getActionsFields = async () => {
    let url = `/automation/action-fields/3`;
    Api.get(url)
      .then((result) => {
        if (result.data.success) {
          const data = result.data.data.filter(
            (item) =>
              item.name !== "Atribuir obsevador"
          );

          const uniqueByName = data.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.name === item.name)
          );

          this.setState({
            actionsFields: uniqueByName,
            actionFieldDetail: data,
          });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  async getOrganizationFields(organizationId) {
    if (!organizationId) return [];
    try {
      const result = await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationAndCategories(organizationId);
      if (result.success) return result.data ?? [];
      return [];
    } catch (err) {
      return [];
    }
  }

  getOrganizationFieldsByCategory = async (categoryId) => {
    try {
      if (!categoryId || categoryId <= 0) return [];
      const result = await CalledOrganizationChecklistService.GetByOrganizationCategoryIdAndActive(categoryId);
      if (result && result.success && result.data) return result.data;
      return [];
    } catch (err) {
      return [];
    }
  }

  // Handlers para campos básicos
  handleNomeChange = (e) => {
    this.setState({ nomeAutomacao: e.target.value });
  };

  handleAtivoChange = () => {
    this.setState((prevState) => ({ ativo: !prevState.ativo }));
  };

  adicionarAcao = () => {
    this.setState((prevState) => ({
      acoes: [...prevState.acoes, { tipo: null, valor: null, categoriaId: null, considerarCategoria: false, customOrganizationFilterFields: [] }],
    }));
  };

  removerAcao = (index) => {
    const novasAcoes = [...this.state.acoes];
    novasAcoes.splice(index, 1);
    this.setState({ acoes: novasAcoes });
  };

  handleSharingMode = (value, macroShareModeId) => {
    const { macroShareMode } = this.state;

    let checked = false;

    if (value !== null) {
      if (value === true) {
        this.setState({
          macroShareMode: macroShareModeId,
          macroUsersSelected: [],
          macroTechnicalTeamSelected: []
        })
      } else {
        this.setState({
          macroShareMode: null,
          macroUsersSelected: [],
          macroTechnicalTeamSelected: []
        });
      }
    }

    checked = macroShareMode != null && macroShareMode > 1 && macroShareMode == macroShareModeId

    return checked;
  }

  atualizarAcao = (index, campo, valor) => {
    const novasAcoes = [...this.state.acoes];
    novasAcoes[index][campo] = valor;
    this.setState({ acoes: novasAcoes });
  };

  atualizarAcaoTipo = (index, actionsFields, valor) => {  
    this.atualizarAcao(index, "tipo", valor);
  };

  handleAdicionarTag = (index, acao) => {
    const oldValue = acao?.valor ?? "";

    const tagValue = acao?.tagValue ?? "";

    if (tagValue.trim() === "") return;

    const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? [];

    if (oldValueTags.some((tag) => tag.toLowerCase() === tagValue.toLowerCase())) {
      this.atualizarAcao(index, "tagValue", null);

      return;
    }

    const newTagValue =
      oldValue === "" ? tagValue : oldValue + "," + tagValue.trim();

    this.atualizarAcao(index, "valor", newTagValue);

    this.atualizarAcao(index, "tagValue", null);
  };

  handleActionTagInputKeyDown(event, acao, index) {
    const newValue = acao?.tagValue?.trim();

    if (event.key === "Enter" && newValue) {
      if (newValue == "") {
        event.preventDefault();
        return;
      };

      this.handleAdicionarTag(index, acao);

      event.preventDefault();
    }
  }

  handleRemoverTag = (index, acao, tagIndex) => {
    const oldValue = acao?.valor ?? "";
    const oldTags = oldValue?.split(",")?.filter((ac) => ac);

    oldTags.splice(tagIndex, 1);

    this.atualizarAcao(index, "valor", oldTags.join(","));
  };

  getIdFromFieldValue = (value) => {
    if (!value) return null;

    const parts = value.split("_");

    return parts.length > 1 ? parseInt(parts[1]) : null;
  };

  handleChangeOrganization = (value) => {
    this.setState({ organizationId: value });
  };

  returnFields(id, index, customFields) {
    const campoTexto = [];
    const arrayselecao = [];
    const fields = Array.isArray(customFields) ? customFields : this.state.customOrganizationFilterFields;
    const element = fields.find(
      (item) => item.id == id
    ) || {};
    const fieldType = element?.organizationfieldtype;

    if (element.organizationfieldoptionsvalues?.length > 0) {
      element.organizationfieldoptionsvalues.forEach((element2) => {
        if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
          arrayselecao.push(element2);
        }
      });

      if (fieldType == 2) {
        campoTexto.push(
          <Grid item xs={12}>
            <FormControl required={element.isrequired}>
              <FormLabel id="demo-radio-buttons-group-label">
                {element.name}
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
              >
                {arrayselecao.map((item) => (
                  <FormControlLabel
                    name={"ofield-" + element.id}
                    value={item.name + "\n" + item.id}
                    stateName={"ofield-" + element.name}
                    onChange={(e) => {
                      this.atualizarAcao(index, "valor", item.id)
                    }}
                    control={<Radio />}
                    label={item.name}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Grid>
        );
      }

      if (fieldType == 4) {
        campoTexto.push(
          <Grid item xs={6}>
            <SimpleAutoComplete
              selected={this.state[`ofield-${element.id}`]}
              label={element.name}
              options={arrayselecao}
              stateName={"ofield-" + element.id}
              changeSelect={(stateName, value) => {
                this.atualizarAcao(index, "valor", value?.id)
              }}
            />

            {this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Grid>
        );
      }

      if (fieldType == 6) {
        campoTexto.push(
          <Grid item xs={6}>
            <SimpleAutoCompleteMultiple
              label={element.name}
              options={arrayselecao}
              stateName={"ofield-" + element.id}
              changeSelect={(stateName, value) => {
                const valueIds = value?.map(v => v.id).join(",") || [];

                const novasAcoes = [...this.state.acoes];
                novasAcoes[index]["valor"] = valueIds;
                this.setState({ acoes: novasAcoes });
              }}
            />

            {this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Grid>
        );
      }
    }

    if (fieldType == 1) {
      campoTexto.push(
        <Grid item xs={6}>
          <TextField
            autoComplete="fname"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            onChange={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
            inputProps={{
              maxLength: element.maxlength ? element.maxlength : 250,
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 3) {
      campoTexto.push(
        <Grid item xs={12}  >
          <SimpleCheckBox
            selected={this.state[`ofield-${element.id}`] === "true"}
            label={element.name}
            name={"ofield-" + element.id}
            stateName={"ofield-" + element.id}
            changeSelect={(stateName, value) => {
              this.atualizarAcao(index, "valor", value);
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 5) {
      campoTexto.push(
        <Grid item xs={6}>
          <TextField
            type="text"
            autoComplete="off"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: element.maxlength || 250,
            }}
            onChange={(e) => {
              const value = e.target.value;
              const numericValue = value.replace(/\D/g, '');

              if (numericValue.length <= (element.maxlength || 250)) {
                this.atualizarAcao(index, "valor", numericValue);
              }
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 7) {
      campoTexto.push(
        <Grid item xs={12}>
          <TextField
            autoComplete="fname"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            multiline 
            rows={element.maxlength}
            onChange={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 8) {
      campoTexto.push(
        <Grid item xs={6}>
          <TextField
            type="text"
            autoComplete="off"
            name={"ofield-" + element.id}
            variant="outlined"
            id={"ofield-" + element.id}
            label={element.name}
            fullWidth
            inputProps={{
              inputMode: 'decimal',
              pattern: '^[0-9]*[.,]?[0-9]*$',
              maxLength: element.maxlength || 250
            }}
            onChange={(e) => {
              let value = e.target.value.replace(',', '.');
              const numericValue = value.replace(/[^0-9.]/g, '');

              if (numericValue.length <= (element.maxlength || 250)) {
                this.atualizarAcao(index, "valor", numericValue);
              }
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 9) {
      const getValue = this.state.acoes[index]?.valor ? this.state.acoes[index]?.valor : null;

      let valueFormat = getValue ? new Date(getValue) : null;
      if (getValue) {
        if (typeof getValue === "string" && getValue.includes("/")) {
          const [day, month, year] = getValue.split("/");
          valueFormat = new Date(year, month - 1, day);
        } else {
          valueFormat = new Date(getValue + "T00:00:00");
        }
      }

      campoTexto.push(
        <Grid item xs={6}>
          <SimpleDatePickerRequired
            currentDate={valueFormat}
            label={element.name}
            stateName={"ofield-" + element.id}
            toolTipTitle={element.name}
            changeDate={(stateName, date) => {
              this.atualizarAcao(index, "valor", date)
            }}
          />
        </Grid>
      );
    }

    if (fieldType == 10) {
      const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

      campoTexto.push(
        <Grid item xs={12}>
          <RegexInput
            id={"ofield-" + element.id}
            name={"ofield-" + element.id}
            label={element.name}
            regex={regex}
            hasError={!!this.state?.errors?.acoes?.[index]?.valor}
            errorMessage={this.state?.errors?.acoes?.[index]?.valor}
            onChangeValue={(e) => {
              this.atualizarAcao(index, "valor", e.target.value);
            }}
          />
        </Grid>
      );
    }

    return campoTexto;
  }

  validateImagesAtachments = (files) => {
    this.setState({ files: [...files, ...this.state.files]});
  }

  renderInputsByFieldtype = (acao, index) => {
    const getAction = this.state.actionFieldDetail?.find(
      (field) => field?.id === acao?.tipo
    );
    const getFieldName = getAction?.name ?? null;
    const getFieldId = getAction?.id ?? null;
    const getFieldType = getAction?.fieldtype ?? null;
    const label = getAction?.label ?? "Valor";
    const { classes, intl } = this.props;

    //Categoria
    if (getFieldId == 15) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <RealSimpleAutoComplete
              style={{ background: "white", fullWidth: true }}
              label="Organização"
              options={this.state.organizationsFilterList}
              stateName="organizationId"
              changeSelect={(stateName, value) =>
                this.handleChangeOrganization(value?.id)
              }
              onFocus={this.getFilterOrganizations}
              loading={this.state.loadingOrganizationFilter}
              selected={this.state.organizationsFilterList.find(
                (item) => item.id == this.state.organizationId
              )}
            />
                      
            {this.state.errors.organizationId && (
              <FormHelperText error>
                {this.state.errors.organizationId}
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <RealSimpleAutoComplete
              style={{ background: "white", fullWidth: true }}
              label="Categoria do Chamado"
              options={this.state.categoriesFilterList}
              stateName=""
              changeSelect={(_, value) => {
                this.atualizarAcao(
                  index,
                  "valor",
                  value?.id
                )
              }}
              onFocus={this.getFilterCategoriesByOrganization}
              loading={this.state.loadingCategoryFilter}
              selected={
                this.state.categoriesFilterList.
                  find(item => item.id == acao.valor) ?? null
              }
            />

            {this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Grid>
        </>
      );
    }

    //Anexo
    if (getFieldId == 18) {
      return (
        <>
        <Grid item xs={12} sm={12}>
          <section style={{ width: '100%' }}>
            <div className={classes.dropzoneArea}>
              <Dropzone onDrop={acceptedFiles => this.validateImagesAtachments(acceptedFiles)}>
                {({ getRootProps, getInputProps, acceptedFiles }) => (
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>{<FormattedMessage id="drag.and.drop" />}</p>
                  </div>
                )}
              </Dropzone>
              {this.state.files.map(file => {
                return (
                  <div className={classes.dropzoneItem} key={file.name}>
                    {file.name}
                    <DeleteForever className={classes.deleteItem} onClick={() => { this.removeItem(file) }} />
                  </div>
                )
              })}
            </div>
          </section>

          {this.state.errors.acoes?.[index]?.files && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.files}
            </FormHelperText>
          )}
        </Grid>
        </>
      );
    }
    
    //Organização
    if (getFieldId == 19) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Organização"
            options={this.state.organizationsFilterList}
            stateName="organizationId"
            changeSelect={(stateName, value, text = "") => {
              this.atualizarAcao(index, "valor", value?.id);
              this.handleChangeOrganization(value?.id);
            }}
            onFocus={this.getFilterOrganizations}
            loading={this.state.loadingOrganizationFilter}
            selected={this.state.organizationsFilterList.find(
              (item) => item.id == this.state.organizationId
            )}
          />
                    
          {this.state.errors.organizationId && (
            <FormHelperText error>
              {this.state.errors.organizationId}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Campo personalizado
    if (getFieldId == 14) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Organização"
                options={this.state.organizationsFilterList}
                stateName="organizationId"
                changeSelect={async (stateName, value) => {
                  this.setState({ loading: true, categoriesFilterList: [] });
                  this.handleChangeOrganization(value?.id);
                  this.atualizarAcao(index, "categoriaId", null);
                  this.atualizarAcao(index, "considerarCategoria", false);
                  const fields = await this.getOrganizationFields(value?.id);
                  this.atualizarAcao(index, "customOrganizationFilterFields", fields ?? []);
                  this.setState({ loading: false });
                }}
                onFocus={this.getFilterOrganizations}
                loading={this.state.loadingOrganizationFilter}
                selected={this.state.organizationsFilterList.find(
                  (item) => item.id == this.state.organizationId
                )}
              />

              {this.state.errors.organizationId && (
                <FormHelperText error>
                  {this.state.errors.organizationId}
                </FormHelperText>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={acao.considerarCategoria ?? false}
                  onChange={async (e) => {
                    const checked = e.target.checked;
                    this.atualizarAcao(index, "considerarCategoria", checked);
                    this.atualizarAcao(index, "categoriaId", null);
                    if (!checked) {
                      this.setState({ loading: true });
                      const fields = await this.getOrganizationFields(this.state.organizationId);
                      this.atualizarAcao(index, "customOrganizationFilterFields", fields ?? []);
                      this.setState({ loading: false });
                    } else {
                      this.atualizarAcao(index, "customOrganizationFilterFields", []);
                    }
                  }}
                />
              }
              label="Considerar categoria?"
            />
          </Grid>
          {acao.considerarCategoria && (
            <Grid item xs={12} sm={6}>
              <Grid item xs={12} sm={12}>
                <RealSimpleAutoComplete
                  style={{ background: "white", fullWidth: true }}
                  label="Categoria"
                  options={this.state.categoriesFilterList}
                  stateName="categoriaId"
                  changeSelect={async (stateName, value) => {
                    this.atualizarAcao(index, "categoriaId", value?.id ?? null);
                    if (value?.id) {
                      this.setState({ loading: true });
                      const fields = await this.getOrganizationFieldsByCategory(value.id);
                      this.atualizarAcao(index, "customOrganizationFilterFields", fields ?? []);
                      this.setState({ loading: false });
                    } else {
                      this.atualizarAcao(index, "customOrganizationFilterFields", []);
                    }
                  }}
                  onFocus={this.getFilterCategoriesByOrganization}
                  loading={this.state.loadingCategoryFilter}
                  selected={this.state.categoriesFilterList.find((item) => item.id == acao.categoriaId) ?? null}
                />
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} sm={acao.considerarCategoria ? 6 : 12}>
            <Grid item xs={12} sm={12}>
              <SimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Campos personalizados"
                options={acao.customOrganizationFilterFields ?? []}
                stateName="organizationFieldId"
                changeSelect={(stateName, value, text = "") => {
                  const novasAcoes = [...this.state.acoes];

                  if (value && value.id && value.organizationfieldtype && value.organizationfieldtype == 9) {
                    novasAcoes[index][stateName] = value?.id;
                    novasAcoes[index]["valor"] = new Date();
                    this.setState({ acoes: novasAcoes });
                    return;
                  }

                  novasAcoes[index]["organizationfieldtype"] = value.organizationfieldtype || null;
                  novasAcoes[index]["valor"] = null;
                  this.setState({ acoes: novasAcoes });

                  this.atualizarAcao(index, stateName, value?.id);
                }}
                value={() => {
                  return (
                    (acao.customOrganizationFilterFields ?? []).find(
                      (item) => item.id == acao.organizationFieldId
                    ) ?? null
                  );
                }}
              />

              {this.state.errors.acoes?.[index]?.organizationFieldId && (
                <FormHelperText error>
                  {this.state.errors.acoes?.[index]?.organizationFieldId}
                </FormHelperText>
              )}
            </Grid>
          </Grid>

          {acao.organizationFieldId != null && (
            this.returnFields(acao.organizationFieldId, index, acao.customOrganizationFilterFields)
          )}
        </>
      );
    }

    //Localização
    if (getFieldId == 20) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Organização"
                options={this.state.organizationsFilterList}
                stateName="organizationId"
                changeSelect={(stateName, value) =>
                  this.handleChangeOrganization(value?.id)
                }
                onFocus={this.getFilterOrganizations}
                loading={this.state.loadingOrganizationFilter}
                selected={this.state.organizationsFilterList.find(
                  (item) => item.id == this.state.organizationId
                )}
              />

              {this.state.errors.organizationId && (
                <FormHelperText error>
                  {this.state.errors.organizationId}
                </FormHelperText>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Localização"
                options={this.state.localizationFilterList}
                stateName="localizationid"
                onFocus={this.getFilterLocalizationByOrganization}
                loading={this.state.loadingLocalizationFilter}
                changeSelect={(stateName, value, text = "") => {
                  this.atualizarAcao(index, "valor", value?.id);
                }}
                value={() => {
                  return (
                    this.state.localizationFilterList.find(
                      (item) => item.id == acao.valor
                    ) ?? null
                  );
                }}
              />

              {this.state.errors.acoes?.[index]?.valor && (
                <FormHelperText error>
                  {this.state.errors.acoes?.[index]?.valor}
                </FormHelperText>
              )}
            </Grid>
          </Grid>

        </>
      );
    }

    //Solicitante
    if (getFieldId == 21) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Organização"
                options={this.state.organizationsFilterList}
                stateName="organizationId"
                changeSelect={(stateName, value) =>
                  this.handleChangeOrganization(value?.id)
                }
                onFocus={this.getFilterOrganizations}
                loading={this.state.loadingOrganizationFilter}
                selected={this.state.organizationsFilterList.find(
                  (item) => item.id == this.state.organizationId
                )}
              />

              {this.state.errors.organizationId && (
                <FormHelperText error>
                  {this.state.errors.organizationId}
                </FormHelperText>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item xs={12} sm={12}>
              <RealSimpleAutoComplete
                style={{ background: "white", fullWidth: true }}
                label="Solicitante"
                options={this.state.userRequestFilterList}
                stateName="userrequestid"
                onFocus={this.getFilterRequestUserByOrganization}
                loading={this.state.loadingUserRequestFilter}
                changeSelect={(stateName, value, text = "") => {
                  this.atualizarAcao(index, "valor", value?.id);
                }}
                value={() => {
                  return (
                    this.state.userRequestFilterList.find(
                      (item) => item.id == acao.valor
                    ) ?? null
                  );
                }}
              />

              {this.state.errors.acoes?.[index]?.valor && (
                <FormHelperText error>
                  {this.state.errors.acoes?.[index]?.valor}
                </FormHelperText>
              )}
            </Grid>
          </Grid>

        </>
      );
    }

    //Ação padrão
    if (getFieldId == 9) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Ação do chamado"
            options={this.state.defaultactionFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterDefaultAction}
            loading={this.state.loadingDefaultactionFilter}
            selected={() => {
              return (
                this.state.defaultactionFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
                    
          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Tipo
    if (getFieldId == 2) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Tipo do chamado"
            options={this.state.typeFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterType}
            loading={this.state.loadingTypeFilter}
            selected={() => {
              return (
                this.state.typeFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
                    
          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Prioridade
    if (getFieldId == 1) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Prioridade do chamado"
            options={this.state.priorityFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterPriority}
            loading={this.state.loadingPriorityFilter}
            selected={() => {
              return (
                this.state.priorityFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
                    
          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Status
    if (getFieldId == 3) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Status do chamado"
            options={this.state.statusFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterStatus}
            loading={this.state.loadingStatusFilter}
            selected={() => {
              return (
                this.state.statusFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />
          
          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Agente 6
    if (getFieldId == 6) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Atribuir Agente"
            options={this.state.assignedUserFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            onFocus={this.getFilterAssignedUser}
            loading={this.state.loadingAssignedUserFilter}
            selected={() => {
              return (
                this.state.assignedUserFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />

          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Observador 7
    if (getFieldId == 7) {
      return (
        <Grid item xs={12} sm={6}>
          <SimpleAutoCompleteMultipleObservant
            label="Atribuir Observador"
            options={this.state.assignedUserFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value)
            }
            selected={Array.isArray(acao.valor) ? acao.valor : []}
            freeSolo={true}
            onOpen={this.getFilterAssignedUser}
            loading={this.state.loadingAssignedUserFilter}
          />

          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Time
    if (getFieldId == 8) {
      return (
        <Grid item xs={12} sm={6}>
          <RealSimpleAutoComplete
            style={{ background: "white", fullWidth: true }}
            label="Time do chamado"
            options={this.state.techinicalTeamFilterList}
            stateName=""
            changeSelect={(stateName, value) =>
              this.atualizarAcao(index, "valor", value?.id)
            }
            loading={this.state.loadingTechinicalTeamFilter}
            selected={() => {
              return (
                this.state.techinicalTeamFilterList.find(
                  (item) => item.id == acao.valor
                ) ?? null
              );
            }}
          />

          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    //Descrição
    if (getFieldId == 17) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <Stack
              spacing={1}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <TextField
                fullWidth
                label="Descrição do chamado"
                multiline
                rows={8}
                value={acao.valor ?? ""}
                onChange={(e) =>
                  this.atualizarAcao(
                    index,
                    "valor",
                    e.target.value
                  )
                }
                placeholder="Descrição do chamado"
                error={!!this.state.errors.acoes?.[index]?.valor}
                helperText={this.state.errors.acoes?.[index]?.valor}
                inputRef={this.getOrCreateActionRef(index)}
              />

              <AddCommonPlaceholder
                onChange={(value) => {
                  this.atualizarAcao(index, "valor", value);
                }}
                value={acao.valor ?? ""}
                types={[1,4]}
                textAreaRef={this.getOrCreateActionRef(index)}
                insertAtCursor
              />
            </Stack>
          </Grid>
        </>
      );
    }

    //Acompanhamento
    if (getFieldId == 4) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <RadioGroup
              aria-label="privacy"
              name="privacy"
              value={acao.action}
              row
              onChange={(e) => {
                this.atualizarAcao(index, "action", e.target.value);
              }}
            >
              <FormControlLabel
                value="false"
                control={<Radio color="primary" />}
                label={intl.formatMessage({ id: "public.action" })}
                labelPlacement="end"
              />
              <FormControlLabel
                value="true"
                control={<Radio />}
                label={intl.formatMessage({ id: "private.action" })}
                labelPlacement="end"
              />
            </RadioGroup>
          </Grid>
          
          <Grid item xs={12} sm={12}>
            <Stack
              spacing={1}
              direction="row"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <TextField
                fullWidth
                label="Acompanhamento"
                multiline
                rows={8}
                value={acao.valor ?? ""}
                onChange={(e) =>
                  this.atualizarAcao(
                    index,
                    "valor",
                    e.target.value
                  )
                }
                placeholder="Acompanhamento"
                error={!!this.state.errors.acoes?.[index]?.valor}
                helperText={this.state.errors.acoes?.[index]?.valor}
                inputRef={this.getOrCreateActionRef(index)}
              />

              <AddCommonPlaceholder
                onChange={(value) => {
                  this.atualizarAcao(index, "valor", value);
                }}
                value={acao.valor ?? ""}
                types={[1,4]}
                textAreaRef={this.getOrCreateActionRef(index)}
                insertAtCursor
              />
            </Stack>
          </Grid>
        </>
      );
    }

    //Definir titulo do chamado
    if (getFieldId == 16) {
      return (
        <Grid item xs={12} sm={6}>
          <Stack
            spacing={1}
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <TextField
              fullWidth
              label="Titulo do chamado"
              value={acao.valor ?? ""}
              onChange={(e) =>
                this.atualizarAcao(index, "valor", e.target.value)
              }
              placeholder="Título do chamado"
              error={!!this.state.errors.acoes?.[index]?.valor}
              inputRef={this.getOrCreateActionRef(index)}
            />

            <AddCommonPlaceholder
              onChange={(value) => {
                this.atualizarAcao(index, "valor", value);
              }}
              value={acao.valor ?? ""}
              types={[1,4]}
              textAreaRef={this.getOrCreateActionRef(index)}
              insertAtCursor
            />
          </Stack>
    
          {this.state.errors.acoes?.[index]?.valor && (
            <FormHelperText error>
              {this.state.errors.acoes?.[index]?.valor}
            </FormHelperText>
          )}
        </Grid>
      );
    }

    if (getFieldId == 13) {
      const acaoSplit = acao?.valor?.split(",")?.filter((ac) => ac);

      return (
        <Grid item xs={12} sm={8}>
          <Stack spacing={2} direction="column">
            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                label={label}
                value={acao?.tagValue ?? ""}
                onChange={(e) => this.atualizarAcao(index, "tagValue", e.target.value)}
                placeholder="Valor para a ação"
                onKeyDown={(e) =>
                  this.handleActionTagInputKeyDown(
                    e,
                    acao,
                    index
                  )}
              />

              <Button
                aria-label="addNewValue"
                onClick={() => this.handleAdicionarTag(index, acao)}
              >
                <AddRoundedIcon />
              </Button>
            </Stack>

            {!!acaoSplit?.length && (
              <Stack direction="row" gap={1} flexWrap={"wrap"}>
                {acaoSplit?.map((tag, tagIndex) => (
                  <Chip
                    key={tagIndex}
                    label={tag}
                    color="primary"
                    variant="outlined"
                    onDelete={() =>
                      this.handleRemoverTag(index, acao, tagIndex)
                    }
                  />
                ))}
              </Stack>
            )}

            {!!this.state.errors.acoes?.[index]?.valor && (
              <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                {this.state.errors.acoes?.[index]?.valor}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
      );
    }

    return (
      <Grid item xs={12} sm={6}>
        <Stack
          spacing={1}
          direction="row"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <TextField
            fullWidth
            label={label}
            value={acao.valor ?? ""}
            onChange={(e) => this.atualizarAcao(index, "valor", e.target.value)}
            placeholder="Valor para a ação"
            error={!!this.state.errors.acoes?.[index]?.valor}
            helperText={this.state.errors.acoes?.[index]?.valor}
            inputRef={this.getOrCreateActionRef(index)}
          />

          <AddCommonPlaceholder
            onChange={(value) => {
              this.atualizarAcao(index, "valor", value);
            }}
            value={acao.valor}
            types={[1,4]}
            textAreaRef={this.getOrCreateActionRef(index)}
            insertAtCursor
          />
        </Stack>
      </Grid>
    );
  };

  cleanListFromAny = (listForFilter, listForFilterField, listPopulate, listPopulateField, currentIndex, isCustomFieldValue = false) => {
    if (!Array.isArray(listForFilter) || listForFilter.length === 0) return [];

    if (!Array.isArray(listPopulate) || listPopulate.length === 0) return listForFilter;

    let _listPopulate = [...listPopulate];

    _listPopulate = _listPopulate.filter((_, index) => index !== currentIndex);

    let listWithFilterVariables = new Set();

    if (isCustomFieldValue) {
      listWithFilterVariables = new Set(
        _listPopulate
          .filter(i => this.getIdFromFieldValue(i[listPopulateField]))
          .map(item => this.getIdFromFieldValue(item[listPopulateField]))
      );
    } else {
      listWithFilterVariables = new Set(
        _listPopulate.filter(i => i[listPopulateField])
          .map(item => item[listPopulateField])
      );
    }

    const filter = listForFilter
      .filter(item => item[listForFilterField] && !listWithFilterVariables.has(item[listForFilterField]));

    return filter;
  }

  handleResetForm = () => {
    this.setState({
      nomeAutomacao: "",
      ativo: true,
      macroShareMode: 4,

      macroUsersSelected: [],
      macroTechnicalTeamSelected: [],

      acoes: [
        {
          tipo: null,
          valor: null,
          body: `Olá {{ticket.requester.name}},

Informamos que seu chamado foi atualizado.

Status: {{ticket.status.name}}
Prioridade: {{ticket.priority.name}}
Técnico responsável: {{ticket.technical.name}}

Para mais detalhes, acesse: {{ticket.url}}

Atenciosamente,
{{hirer.name}}`,
          subject: "Chamado #{{ticket.id}} - {{ticket.title}}",
          requestingUserId: "",
          newCallTitle: "",
          newCallDescription: "",
          newCallProperties: "",
          newCallOrganizationId: "",
          setCategoryOrganizationValue: "",
          setCategoryOrganizationId: "",
        },
      ],

      errors: {},
    });
  };

  closeNotification = () => {
    this.setState({ openNotification: false });
  };

  validarFormulario() {
    const form = this.state;

    const novosErros = {};
    const acoesErros = [];

    const commonErrorText = "Campo obrigatório.*";

    // INICIO VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS
    if (!form.nomeAutomacao.trim()) {
      novosErros.nomeAutomacao = commonErrorText;
    }
    // FIM VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS

    // INICIO VALIDAÇÃO SHARING
    if (form.macroShareMode == null) {
      novosErros.macroShareMode = "Selecione um modo de compartilhamento.*";
    } else {
      if (form.macroShareMode == 2 && form.macroUsersSelected.length == 0) {
        novosErros.macroShareMode = "Selecione os agentes que terão acesso.*";
      } else if (form.macroShareMode == 3 && form.macroTechnicalTeamSelected.length == 0) {
        novosErros.macroShareMode = "Selecione os times que terão acesso.*";
      }
    }
    // FIM VALIDAÇÃO DOS SHARING

    // AÇÕES VAZIAS
    if(!form.acoes.length) {
      novosErros.acoes = { action: "Adicione ao menos uma ação para a automação.*" }
    }

    //INICIO VALIDAÇÃO DAS AÇÕES
    form.acoes.forEach((acao, index) => {
      const itemErros = {};

      if (!acao.tipo) {
        itemErros.tipo = commonErrorText;
      }

      const actionIdsNeedOrganization = [15, 20, 21];

      if (actionIdsNeedOrganization.includes(acao.tipo) && (!form.organizationId || form.organizationId == 0)) {
        novosErros.organizationId = "Selecione uma organização.*";
      }

      // Exlude "valor" validation for "anexo", "organização" and "observador" actions
      if (!acao.valor && acao.tipo != 18 && acao.tipo != 19 && acao.tipo != 7) {
        itemErros.valor = commonErrorText;
      }

      // Validate "observador" action
      if (acao.tipo == 7 && (!Array.isArray(acao.valor) || !acao.valor.length)) {
        itemErros.valor = "Selecione ao menos um observador.*";
      }

      if (acao.tipo == 3 && !acao.valor) {
        itemErros.valor = "Selecione o status do chamado.*";
      }

      if (acao.tipo == 4 && (!acao.valor || !acao.action)) {
        itemErros.valor = "Preencha o acompanhamento do chamado e se ação vai ser publica ou privada.*";
      }

      // Validate "campo personalizado" action
      const getCustomField = this.state.customOrganizationFilterFields?.find(
        (field) => field?.id === acao?.organizationFieldId
      ) || {};

      if (acao.tipo == 14 && !acao.valor) {
        if (!acao.organizationFieldId && !!form.organizationId) {
          itemErros.organizationFieldId = "Selecione um campo personalizado.*";
        }

        if (Array.isArray(acao.valor) && !acao.valor.length) {
          itemErros.valor = "Selecione ao menos um valor para o campo personalizado.*";
        } else {
          if (!acao.valor) {
            itemErros.valor = "Selecione um valor para o campo personalizado.*";
          }
        }
      }

      if(acao.tipo == 14 && !!acao.valor && getCustomField.organizationfieldtype == 10) {        
        const regex = getCustomField.organizationfieldoptionsvalues.length > 0 ? getCustomField.organizationfieldoptionsvalues[0].name : '';

        const isValidValue = validateRegex(regex, acao.valor);
      
        if (!isValidValue) {
          itemErros.valor = "O valor não corresponde ao formato esperado para este campo.*";
        }
      }

      // Validate "categoria" action
      if (acao.tipo == 15 && !acao.valor) {
        itemErros.valor = "Selecione uma categoria.*";
      }

      // Validate "anexo" action
      if (acao.tipo == 18 && !form.files.length) {
        itemErros.files = "Adicione ao menos um anexo.*";
      }
    
      // Validate "organização" action
      if (acao.tipo == 19 && (!form.organizationId || form.organizationId == 0)) {
        novosErros.organizationId = "Selecione uma organização.*";
      }

      // Validate "localização" action
      if (acao.tipo == 20 && !acao.valor) {
        itemErros.valor = "Selecione uma localização.*";
      }

      // Validate "solicitante" action
      if (acao.tipo == 21 && !acao.valor) {
        itemErros.valor = "Selecione um solicitante.*";
      }

      if (Object.keys(itemErros).length > 0) {
        acoesErros[index] = itemErros;
      }
    });

    if (acoesErros.length > 0) {
      novosErros.acoes = acoesErros;
    }
    // FIM DA VALIDAÇÃO DAS AÇÕES

    this.setState({ errors: novosErros });

    return Object.keys(novosErros).length === 0;
  }

  handleSourceValidation(value) {
    const isString = typeof value === "string" && value.trim().length > 0;

    if (isString) {
      return {
        sourceEntityValue: value,
      }
    }

    return {
      sourceEntityId: value,
    }
  }

  salvarAutomacao = () => {
    this.setState({ loading: true });

    if (!this.validarFormulario()) {
      const notificationMessage = "Por favor, preencha todos os campos obrigatórios.";

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage,
        loading: false,
      });
      return;
    }

    //SHARING
    const macroUsers = this.state.macroUsersSelected.map(item => item.id);
    const macroTechnicalTeam = this.state.macroTechnicalTeamSelected.map(item => item.id);

    // FIM SHARING

    //ACOES DATA
    const macroAutomationActionData =
      this.state.acoes.map((acao) => {
        const getAction = this.state.actionsFields?.find(
          (field) => field?.id === acao?.tipo
        );

        const getActionid = getAction?.id ?? null;

        //Campo personalizado
        if (getActionid == 14) {
          return {
            automationActionId: getActionid,
            sourceEntityId: acao?.organizationFieldId ?? 0,
            sourceEntityValue: acao?.valor ?? "",
            organizationFieldCategoryId: acao?.categoriaId ?? null,
          };
        }

        const actionIdsNeedOrganization = [15, 20, 21];

        if (actionIdsNeedOrganization.includes(getActionid)) {
          return {
            automationActionId: getActionid, //o id do campo "ação"
            sourceEntityId: this.state.organizationId ?? 0,
            sourceEntityValue: acao?.valor ?? "",
          };
        }

        if (getActionid == 7) {
          return {
            automationActionId: getActionid,
            sourceEntityId: 0,
            sourceEntityValue: JSON.stringify(acao?.valor || []),
          };
        }

        const actionIdsText = [4, 13, 16, 17, 18];

        if (actionIdsText.includes(getActionid)) {
          if(getActionid == 4) {
            return {
              automationActionId: getActionid, //o id do campo "ação"
              sourceEntityId: 0,
              sourceEntityValue: JSON.stringify({text: acao?.valor ?? "", privacy: acao?.action == "true"}),
            }
          }

          return {
            automationActionId: getActionid, //o id do campo "ação"
            sourceEntityId: 0,
            sourceEntityValue: acao?.valor ?? "",
          };
        }

        return {
          automationActionId: getActionid,
          sourceEntityId: acao?.valor,
          sourceEntityValue: "",
        };
      });

    const formData = new FormData();

    formData.append("Name", this.state.nomeAutomacao);
    formData.append("Active", this.state.ativo);
    formData.append("MacroShareMode", this.state.macroShareMode);

    macroUsers.forEach((u, i) => formData.append(`MacroUsers[${i}]`, u));
    macroTechnicalTeam.forEach((t, i) => formData.append(`MacroTechnicalTeam[${i}]`, t));

    macroAutomationActionData.forEach((action, i) => {
      formData.append(`MacroAutomationAction[${i}].AutomationActionId`, action.automationActionId);
      formData.append(`MacroAutomationAction[${i}].SourceEntityId`, action.sourceEntityId ?? 0);
      formData.append(`MacroAutomationAction[${i}].SourceEntityValue`, action.sourceEntityValue ?? "");
      if (action.organizationFieldCategoryId != null) {
        formData.append(`MacroAutomationAction[${i}].OrganizationFieldCategoryId`, action.organizationFieldCategoryId);
      }

      if (action.automationActionId == 18) {
        this.state.files.forEach(file => {
          formData.append("FilesUpload", file, file.name);
        });
      }
    });

    let url = `/macro`;
    Api.post(url, formData, { 'Content-Type': 'multipart/form-data' })
      .then((result) => {
        if (result.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "success",
            notificationMessage: "Macro criada com sucesso!",
          });
          this.handleResetForm();
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };


  removeItem = (file) => {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  render() {
    const {
      nomeAutomacao,
      ativo,
      acoes,
      errors,
      macroShareMode
    } = this.state;
    const { classes, headerMenu, actionsHeaderMenu } = this.props;

    const actionsFields = this.state.actionsFields;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    const isPrivateSharedMode = macroShareMode != null && macroShareMode == 1;
    const isPublicSharedMode = macroShareMode != null && macroShareMode > 1;

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />
          <Container component="main" maxWidth="lg">
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={browserHistory.goBack}
                  >
                    {<FormattedMessage id="back" />}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar style={{ backgroundColor: "#3f51b4" }}>
                <AutomationIcon />
              </Avatar>
              <Typography
                component="h1"
                variant="h5"
                style={{ marginTop: "10px" }}
              >
                {<FormattedMessage id="add.authentication" />}
                <Title />
              </Typography>
              <form name="myForm" className={classes.form}>
                <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
                  <Typography variant="h4" component="h1" gutterBottom>
                    Criação de Macro
                  </Typography>

                  {/* Informações básicas */}
                  <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                      Informações Básicas
                    </Typography>

                    <TextField
                      label="Nome do Macro de Automação"
                      fullWidth
                      margin="normal"
                      value={nomeAutomacao}
                      onChange={this.handleNomeChange}
                      placeholder="Ex: Atribuir tickets urgentes"
                      error={!!this.state.errors.nomeAutomacao}
                      helperText={this.state.errors.nomeAutomacao}
                    />

                    <FormControlLabel
                      control={
                        <Switch
                          checked={ativo}
                          onChange={this.handleAtivoChange}
                          color="primary"
                        />
                      }
                      label="Macro Ativa"
                      sx={{ mt: 1 }}
                    />
                  </Paper>

                  {/* Sharing */}
                  <Accordion defaultExpanded sx={{ mb: 3 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="eventos-content"
                      id="eventos-header"
                    >
                      <Typography variant="h6">Compartilhamento</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Alert severity="success" sx={{ mb: 2 }}>
                        Define se a macro será apenas para uso pessoal ou se ela será compartilhada com outros agentes.
                      </Alert>

                      <Stack direction="column" marginX={1} sx={{ mb: 2 }}>
                        <SimpleCheckBox
                          disabled={!this.state.allowCreatePrivateMacro}
                          selected={isPrivateSharedMode}
                          label="Macro pessoal"
                          name={"PRIVATE"}
                          stateName={"PRIVATE"}
                          changeSelect={(stateName, value) => {
                            this.handleSharingMode(value, 1)
                          }}
                        />

                        <SimpleCheckBox
                          selected={isPublicSharedMode}
                          label="Macro compartilhada"
                          name={"PUBLIC_MACRO"}
                          stateName={"PUBLIC_MACRO"}
                          changeSelect={(stateName, value) => {
                            this.handleSharingMode(value, 4)
                          }}
                          disabled={!this.state.allowCreateShareMacro}
                        />

                        {isPublicSharedMode && (
                          <Stack direction="column" marginX={2} sx={{ mb: 2 }}>
                            <SimpleCheckBox
                              selected={this.handleSharingMode(null, 4)}
                              label="Com todas as equipes"
                              name={"ALL_TEAMS"}
                              stateName={"ALL_TEAMS"}
                              changeSelect={(stateName, value) => {
                                this.handleSharingMode(value, 4)
                              }}
                            />

                            <SimpleCheckBox
                              selected={this.handleSharingMode(null, 3)}
                              label="Com as sequintes equipes:"
                              name={"TEAMS"}
                              stateName={"TEAMS"}
                              changeSelect={(stateName, value) => {
                                this.handleSharingMode(value, 3)
                              }}
                            />

                            {this.handleSharingMode(null, 3) && (
                              <SimpleAutoCompleteMultiple
                                label={"Equipes para compartilhar"}
                                stateName='TEAMS_IDS'
                                selected={this.state.macroTechnicalTeamSelected}
                                options={this.state.techinicalTeamFilterList}
                                changeSelect={(stateName, value) => {
                                  this.setState({ macroTechnicalTeamSelected: value })
                                }}
                              />
                            )}

                            <SimpleCheckBox
                              selected={this.handleSharingMode(null, 2)}
                              label="Com as sequintes agentes:"
                              name={"USERS"}
                              stateName={"USERS"}
                              changeSelect={(stateName, value) => {
                                this.handleSharingMode(value, 2)
                              }}
                            />

                            {this.handleSharingMode(null, 2) && (
                              <SimpleAutoCompleteMultiple
                                label={"Agentes para compartilhar"}
                                stateName='USERS_IDS'
                                selected={this.state.macroUsersSelected}
                                options={this.state.macroUsers}
                                changeSelect={(stateName, value) => {
                                  this.setState({ macroUsersSelected: value })
                                }}
                              />
                            )}
                          </Stack>
                        )}

                        {errors?.macroShareMode && (
                          <FormHelperText error sx={{ pb: 1, pt: 1 }}>
                            {errors.macroShareMode}
                          </FormHelperText>
                        )}
                      </Stack>
                    </AccordionDetails>
                  </Accordion>

                  {/* Ações */}
                  <Accordion defaultExpanded sx={{ mb: 3 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="acoes-content"
                      id="acoes-header"
                    >
                      <Typography variant="h6">Ações</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Alert severity="success" sx={{ mb: 2 }}>
                        Defina quais ações serão executadas pela macro dentro do ticket quando ela for selecionada pelo agente responsável
                      </Alert>

                      {errors?.acoes?.action && (
                        <FormHelperText error sx={{ pb: 2, pt: 2 }}>
                          {errors.acoes.action}
                        </FormHelperText>
                      )}

                      {acoes.map((acao, index) => (
                        <Paper
                          key={index}
                          variant="outlined"
                          sx={{ p: 2, mb: 2 }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mb: 2,
                            }}
                          >
                            <Typography variant="subtitle2">
                              Ação {index + 1}
                            </Typography>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.removerAcao(index)}
                              aria-label="Remover ação"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>

                          <Grid container spacing={2} alignItems={"center"}>
                            <Grid item xs={12} sm={6}>
                              <FormControl
                                fullWidth
                                error={!!errors.acoes?.[index]?.tipo}
                              >
                                <InputLabel>Tipo de Ação</InputLabel>
                                <Select
                                  value={acao.tipo}
                                  label="Tipo de Ação"
                                  error={!!errors.acoes?.[index]?.tipo}
                                  onChange={(e) => {
                                    this.atualizarAcaoTipo(
                                      index,
                                      actionsFields,
                                      e.target.value
                                    );
                                    this.atualizarAcao(index, "valor", null);
                                  }}
                                >
                                  {this.cleanListFromAny(actionsFields, "id", acoes, "tipo", index, false)
                                    .map((tipo) => (
                                      <MenuItem key={tipo.label} value={tipo.id}>
                                        {tipo?.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                                
                                {errors.acoes?.[index]?.valor && (
                                  <Box height={16} width="100%" />
                                )}

                                {errors.acoes?.[index]?.tipo && (
                                  <FormHelperText error>
                                    {errors.acoes[index].tipo}
                                  </FormHelperText>
                                )}
                              </FormControl>
                            </Grid>

                            {acao.tipo &&
                              this.renderInputsByFieldtype(acao, index)}
                          </Grid>
                        </Paper>
                      ))}

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={this.adicionarAcao}
                        color="primary"
                      >
                        Adicionar ação
                      </Button>
                    </AccordionDetails>
                  </Accordion>

                  {/* Botões de ação */}
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    {!(this.state.allowCreatePrivateMacro == false && this.state.allowCreateShareMacro == false) && (
                      <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={this.salvarAutomacao}
                        color="primary"
                      >
                        Salvar Macro
                      </Button>
                    )}
                    
                  </Stack>
                </Box>
              </form>
            </div>
            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}
            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

MacroRegistration.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});

export default injectIntl(
  connect(mapStateToProps)(withStyles(Styles)(MacroRegistration))
);